var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"relative"}},[_c('swiper',{ref:"SupportedBy",staticClass:"swiper SupportedBySwiper",attrs:{"options":_vm.swiperOptions}},[_vm._t("slides")],2),_vm._t("pagination"),_vm._t("navigation")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }